import { Component, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { PainelManutencoesService } from 'src/app/services/painel-manutencoes.service';
import { ManutencaoBaseComponent } from '../shared/manutencao-base.component';
import { ConfirmacaoPainelManutencoesComponent } from '../confirmacao-painel-manutencoes/confirmacao-painel-manutencoes.component';
import { LoadingGenericoComponent } from '../../../components/loading-generico/loading-generico.component';
import { SuccessGenericoComponent } from '../../../components/success-generico/success-generico.component';
import { ErrorGenericoComponent } from '../../../components/error-generico/error-generico.component';
import { ManutencaoToolbarComponent } from '../shared/manutencao-toolbar/manutencao-toolbar.component';
import { TagManagerDirective } from '../../../directives/tag-manager.directive';
import { ManutencaoFooterComponent } from '../shared/manutencao-footer/manutencao-footer.component';
import { ListaEstadoComponent } from '../../../components/lista-estado/lista-estado.component';

@Component({
    selector: 'app-manutencao-endereco',
    templateUrl: './manutencao-endereco.component.html',
    styleUrls: ['./manutencao-endereco.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ConfirmacaoPainelManutencoesComponent, LoadingGenericoComponent, SuccessGenericoComponent, ErrorGenericoComponent, ManutencaoToolbarComponent, TagManagerDirective, ManutencaoFooterComponent, ListaEstadoComponent]
})
export class ManutencaoEnderecoComponent extends ManutencaoBaseComponent {

  protected readonly sectionApp = 'painel-de-manutencoes';
  protected readonly screenName = 'painel-de-manutencoes:manutencao-de-endereco';
  protected readonly screenType = 'pagina';
  protected readonly inputName = 'inputsEnderecos';

  get enderecos() { return this.dados; }

  constructor(service: PainelManutencoesService) {
    super(service);
  }

  protected excluirUnico(codigo: string) {
    this.loadingDelete = true;
    this.service.deleteEnderecoUnico(this.idEmpresaLogada, codigo).pipe(take(1)).subscribe({
      next: (r: any) => this.handleDeleteResponse(r, () => this.consultar()),
      error: (e: any) => this.handleDeleteError(e)
    });
  }

  protected onTagExcluirSelecionados(checkboxes: any) {
    for (const input of checkboxes) {
      const codEndereco = this.dados.data.find(x => x.codigoCepArquivo === input.id).endereco.codigoCep;
      const model = this.buildTagInteraction('box:button:click', `${input.id}:${codEndereco}'-excluir'`, this.sectionApp, this.screenName, this.screenType);
      this.tagManagerService.pushTag(model);
    }
  }
}
